import React from "react";
import ArrowRightIcon from "icons/ArrowRightIcon";
import CalendarIconSmall from "icons/CalendarIconSmall";

export default function DayRow(props) {
  function dayNameSubscript() {
    if (props.itemType === "task") {
      if (props.taskType === "flexible") {
        return "Target";
      } else {
        return "Due";
      }
    } else if (props.itemType === "calendar_note" && props.activeDate) {
      return "Thru";
    } else {
      return "Date";
    }
  }

  function activeDaySubscript() {
    return props.itemType === "calendar_note" ? "Date" : "Active";
  }

  function dayNameClasses(options) {
    let result = "day-name";
    if (props.itemType === "calendar_note") result += " " + props.colorType;
    if (props.itemType === "task" && options && options.active)
      result += " active";
    return result;
  }

  function activeDayName() {
    return (
      <div className="day-name-container">
        <span className={dayNameClasses({ active: true })}>
          {props.dateHelper.getDayNameLong(props.activeDate, {
            wordNames: "short",
          }) + " -"}
        </span>
        <span className="day-name-subscript">{activeDaySubscript()}</span>
      </div>
    );
  }

  function dueDayName() {
    return (
      <div className="day-name-container">
        <span className={dayNameClasses({})}>
          {props.dateHelper.getDayNameLong(props.itemDay, {
            wordNames: "short",
          })}
        </span>
        <span className="day-name-subscript">{dayNameSubscript()}</span>
      </div>
    );
  }

  function combinedDayName() {
    return (
      <div className="day-name-container">
        <span className={dayNameClasses({})}>
          <span className="arrow-right-icon">
            <ArrowRightIcon />
          </span>
          {props.dateHelper.getDayNameLong(props.itemDay, {
            wordNames: "short",
          })}
        </span>
        <span className="day-name-subscript">
          {activeDaySubscript() + " / " + dayNameSubscript()}
        </span>
      </div>
    );
  }

  function dayNames() {
    const { activeDate, itemType, itemDay } = props;
    if (
      activeDate &&
      itemType === "task" &&
      activeDate.getTime() === itemDay.getTime()
    ) {
      return combinedDayName();
    } else {
      return (
        <>
          {activeDate && activeDayName()}
          {dueDayName()}
        </>
      );
    }
  }

  return (
    <div className="Day-row item-view-row">
      <div className="flex-center-div left-side-icon">
        <CalendarIconSmall />
      </div>
      {dayNames()}
    </div>
  );
}
